import React, { useState, useEffect } from "react";
import { motion, AnimatePresence, delay } from "framer-motion";
import "./partFour.scss";
import { zipImages } from "../../../untils/until";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import { useNavigate } from 'react-router-dom';

interface PartOneProps {
  // scrollPosition: number; // 新增属性用于接收滚动位置
  // mobile: boolean;//是否是移动端
}

const PartTwo: React.FC<PartOneProps> = ({ }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false)

    const navigate = useNavigate();

  const wrapperWidth = window.innerWidth * 0.4
  const wrapperHeight = window.innerHeight * 0.5
  const { i18n } = useTranslation();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
    },
  };

  const leftVariants = {
    hidden: { opacity: 0, x: -window.innerWidth / 2 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1.5,
        delay: 1,
      },
    },
    exit: (direction: any) => ({
      opacity: 0,
      x: -window.innerWidth / 2,
      transition: {
        duration: 1,
        // delay: direction > 0 ? 0 : 0.25 // 方向不同时延迟不同
      },
    }),
  };

  const rightVariants = {
    hidden: { opacity: 0, x: window.innerWidth / 2 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1.5,
        delay: 1,
      },
    },
    exit: (direction: any) => ({
      opacity: 0,
      x: window.innerWidth / 2,
      transition: {
        duration: 1,
        // delay: direction > 0 ? 0 : 0.25 // 方向不同时延迟不同
      },
    }),
  };

  const ipConfig = {
    maxOffset: 20,
    outside: {
      width: 598,
      height: 726,
    },
    inside: {
      width: 324,
      height: 524,
    },
    images: [
      {
        src: zipImages("https://oss.tnworld.cn/eastern/assets/qhc/test.jpg"),
        x: -224,
        y: -50,
        width: 1093,
        height: 615
      }
    ]
  };

  const top = (ipConfig.outside.height - ipConfig.inside.height) / 2
  const left = 0
  // const left = (ipConfig.outside.width - ipConfig.inside.width) / 2
  // const top = (ipConfig.outside.height - ipConfig.inside.height) / 2
  // const zoom = (window.innerHeight * 0.5) / ipConfig.inside.height



  // 计算图片偏移量
  const getImageOffset = () => {
    // 计算鼠标在容器中的相对位置 (0到1之间)
    const container = document.querySelector('.ip-wrapper');
    if (!container) return { x: 0, y: 0 };

    const rect = container.getBoundingClientRect();
    const relativeX = (mousePosition.x - rect.left) / rect.width;
    const relativeY = (mousePosition.y - rect.top) / rect.height;

    // 计算偏移量 (可以根据需要调整乘数来控制移动幅度)
    const offsetX = -(relativeX - 0.5) * ipConfig.maxOffset; // 40是最大偏移量
    const offsetY = -(relativeY - 0.5) * ipConfig.maxOffset;

    return { x: offsetX, y: offsetY };
  };

  const { x: offsetX, y: offsetY } = getImageOffset();

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    // 只在悬停时监听鼠标移动
    if (isHovering) {
      window.addEventListener('mousemove', handleMouseMove);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isHovering]);

    const goAnyWhere = (e:any) => {
      e.stopPropagation();
      navigate('/scene?scene=qinghuaci');
      // message.warning("敬请期待")
    }
  

  return (
    <>
      {/* PC */}

      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="part-content part4"
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <motion.div
          variants={leftVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
          className="half-box"
        >
          <div className="ip-intro">
            <div className="title">{i18n.t(`home_qing_title`)}</div>
            <div className="sub-title">QING HUA CI</div>
            <div className="introduction">
              {i18n.t('home_qing_des').split('\n')[0]} <br />
              {i18n.t('home_qing_des').split('\n')[1]} <br />
              {i18n.t('home_qing_des').split('\n')?.[2]} <br />
              {i18n.t('home_qing_des').split('\n')?.[3]}
            </div>
            <div className="btn" onClick={(e) => { goAnyWhere(e) }} style={{ backgroundImage: `url(${zipImages('https://oss.tnworld.cn/eastern/assets/btn-bg.png')})` }}>{i18n.t(`home_enter_btn`)}</div>
          </div>
        </motion.div>

        <motion.div
          variants={rightVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
          className="half-box"
        >
          <div className="ip-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" style={{ transform: `translate(${left}px, ${top}px)` }} width={ipConfig.outside.width} height={ipConfig.outside.height} viewBox={`0 0 ${ipConfig.outside.width} ${ipConfig.outside.height}`} fill="none">
              <defs>
                {/* 内阴影滤镜*/}
                <filter id="filter0_f_401_1188" x="-32.4988" y="-33.4512" width="388.008" height="589.928" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                  <feGaussianBlur stdDeviation="14" result="effect1_foregroundBlur_401_1188" />
                </filter>

                {/* 外阴影滤镜*/}
                <filter id="filter0_dddddd_401_1184" x="0.27166" y="0.880507" width="596.908" height="724.143" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dx="3.20684" dy="1.81569" />
                  <feGaussianBlur stdDeviation="1.96759" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0.478431 0 0 0 0 0.6 0 0 0 0 0.780392 0 0 0 0.052963 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_401_1184" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dx="14.1101" dy="7.98904" />
                  <feGaussianBlur stdDeviation="4.07407" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0.478431 0 0 0 0 0.6 0 0 0 0 0.780392 0 0 0 0.0863704 0" />
                  <feBlend mode="normal" in2="effect1_dropShadow_401_1184" result="effect2_dropShadow_401_1184" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dx="34.6339" dy="19.6095" />
                  <feGaussianBlur stdDeviation="8.125" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0.478431 0 0 0 0 0.6 0 0 0 0 0.780392 0 0 0 0.11 0" />
                  <feBlend mode="normal" in2="effect2_dropShadow_401_1184" result="effect3_dropShadow_401_1184" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dx="66.7024" dy="37.7664" />
                  <feGaussianBlur stdDeviation="15.9259" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0.478431 0 0 0 0 0.6 0 0 0 0 0.780392 0 0 0 0.13363 0" />
                  <feBlend mode="normal" in2="effect3_dropShadow_401_1184" result="effect4_dropShadow_401_1184" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dx="112.24" dy="63.5492" />
                  <feGaussianBlur stdDeviation="29.2824" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0.478431 0 0 0 0 0.6 0 0 0 0 0.780392 0 0 0 0.167037 0" />
                  <feBlend mode="normal" in2="effect4_dropShadow_401_1184" result="effect5_dropShadow_401_1184" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dx="173.17" dy="98.0473" />
                  <feGaussianBlur stdDeviation="50" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0.478431 0 0 0 0 0.6 0 0 0 0 0.780392 0 0 0 0.22 0" />
                  <feBlend mode="normal" in2="effect5_dropShadow_401_1184" result="effect6_dropShadow_401_1184" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect6_dropShadow_401_1184" result="shape" />
                </filter>

                {/* 图形路径，外阴影路径 */}
                <path id="main-shape" d="M310.012 322.011C316.861 300.464 325.259 278.422 323.855 255.478C321.495 227.257 305.951 200.479 281.865 185.328C262.597 170.322 263.586 177.713 264.014 152.647C263.968 150.954 264.937 149.69 266.058 148.57C269.756 144.822 268.16 140.006 264.634 136.798C284.857 136.271 291.818 124.763 268.464 119.269C267.343 68.9866 224.14 66.2397 185.341 56.3585C184.747 54.178 184.55 53.9079 182.605 52.5509V47.5642C184.622 46.7078 188.261 44.7711 190.232 40.8779C193.33 34.7384 191.662 29.0205 188.01 23.9679C183.251 17.3804 175.11 11.9063 169.771 8.07894C166.771 5.93142 164.253 4.19233 162.52 3C160.766 4.19233 158.248 5.93142 155.269 8.07894C149.929 11.9063 141.788 17.3739 137.029 23.9679C133.377 29.0271 131.709 34.7384 134.808 40.8779C136.785 44.7711 140.417 46.7078 142.434 47.5642V52.5773C140.49 53.9343 140.292 54.2044 139.699 56.3848C100.86 66.2397 57.6896 68.9866 56.5558 119.269C33.201 124.763 40.1619 136.271 60.3857 136.798C56.8591 139.973 55.2638 144.822 58.9619 148.57C60.0825 149.69 61.0515 150.954 61.0053 152.647C61.414 177.713 62.4028 170.295 43.148 185.302C19.0615 200.453 3.51792 227.231 1.15804 255.451C-0.259202 278.422 8.1388 300.464 15.0009 321.985C29.3909 364.599 48.6588 405.646 58.0258 449.841C63.029 467.133 62.528 485.565 52.7523 501.111C42.8646 521.322 67.1819 521.532 80.6754 523.667C97.987 525.595 115.391 526.574 132.81 526.598C142.698 526.908 152.586 526.993 162.526 526.974C172.467 526.954 182.354 526.908 192.242 526.598C209.661 526.574 227.065 525.595 244.377 523.667C257.871 521.513 282.188 521.322 272.3 501.111C262.511 485.565 262.01 467.133 267.027 449.841C276.354 405.698 295.655 364.652 310.012 322.011Z" />
                {/* 内阴影路径 */}
                <path id="inner-shadow" d="M309.012 319.011C315.861 297.464 324.259 275.422 322.855 252.478C320.495 224.257 304.951 197.479 280.865 182.328C261.597 167.322 262.586 174.713 263.014 149.647C262.968 147.954 263.937 146.69 265.058 145.57C268.756 141.822 267.16 137.006 263.634 133.798C283.857 133.271 290.818 121.763 267.464 116.269C266.343 65.9866 223.14 63.2397 184.341 53.3585C183.747 51.178 183.55 50.9079 181.605 49.5509V44.5642C183.622 43.7078 187.261 41.7711 189.232 37.8779C192.33 31.7384 190.662 26.0205 187.01 20.9679C182.251 14.3804 174.11 8.90625 168.771 5.07894C165.771 2.93142 163.253 1.19233 161.52 0C159.766 1.19233 157.248 2.93142 154.269 5.07894C148.929 8.90625 140.788 14.3739 136.029 20.9679C132.377 26.0271 130.709 31.7384 133.808 37.8779C135.785 41.7711 139.417 43.7078 141.434 44.5642V49.5773C139.49 50.9343 139.292 51.2044 138.699 53.3848C99.8596 63.2397 56.6896 65.9866 55.5558 116.269C32.201 121.763 39.1619 133.271 59.3857 133.798C55.8591 136.973 54.2638 141.822 57.9619 145.57C59.0825 146.69 60.0515 147.954 60.0053 149.647C60.414 174.713 61.4028 167.295 42.148 182.302C18.0615 197.453 2.51792 224.231 0.158043 252.451C-1.2592 275.422 7.1388 297.464 14.0009 318.985C28.3909 361.599 47.6588 402.646 57.0258 446.841C62.029 464.133 61.528 482.565 51.7523 498.111C41.8646 518.322 66.1819 518.532 79.6754 520.667C96.987 522.595 114.391 523.574 131.81 523.598C141.698 523.908 151.586 523.993 161.526 523.974C171.467 523.954 181.354 523.908 191.242 523.598C208.661 523.574 226.065 522.595 243.377 520.667C256.871 518.513 281.188 518.322 271.3 498.111C261.511 482.565 261.01 464.133 266.027 446.841C275.354 402.698 294.655 361.652 309.012 319.011Z" stroke="black" strokeOpacity="0.45" strokeWidth="9" />

                {/* 图形蒙版 */}
                <mask id="svgmask">
                  <use href="#main-shape" fill="white" />
                </mask>
              </defs>

              {/* 外阴影滤镜 */}
              <use href="#main-shape" filter="url(#filter0_dddddd_401_1184)" fill="rgba(122, 153, 199, 0.22)" />

              {/* 图片 */}
              <image x={ipConfig.images[0].x + offsetX} y={ipConfig.images[0].y + offsetY} width={ipConfig.images[0].width} height={ipConfig.images[0].height} xlinkHref={ipConfig.images[0].src} mask="url(#svgmask)" />

              {/* 内阴影滤镜 */}
              <use href="#inner-shadow" filter="url(#filter0_f_401_1188)" mask="url(#svgmask)" />
            </svg>
          </div>
        </motion.div>
      </motion.div>
      {/* Mobile */}
    </>
  );
};

export default PartTwo;